const reportImpressionEvent = (config, item) => {
    const { url } = config;
    return new Promise((resolve, reject) =>
        fetch(`${url}/v1/resource/first-i/${item.adId}`, {
            method: 'GET',
            priority: 'low',
        })
            .then((ans) => ans.json().then((json) => resolve(json)))
            .catch((error) => reject(error)));
};

const reportClickEvent = (config, item) => {
    const { url } = config;
    return new Promise((resolve, reject) =>
        fetch(`${url}/v1/resource/second-c/${item.adId}`, {
            method: 'GET',
            priority: 'low',
        })
            .then((ans) => ans.json().then((json) => resolve(json)))
            .catch((error) => reject(error)));
};

const Citrus = {
    reportImpressionEvent,
    reportClickEvent,
};

export default Citrus;
